<template>
  <div class="otherLogin" v-if="mp_login.is_available == 1 && $pub.isWeiXin()&&websiteUnUseWx">
    <p>第三方登录</p>
    <div class="txLogin">
      <div class="wxLogin" @click="otherLogin">
        <img src="@/assets/images/wechat.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OtherLogin",
  data() {
    return {
      websiteUnUseWx: true
    };
  },
  computed: {
    mp_login() {
      return this.config.mpLogin || {};
    },
    config() {
      return this.$store.state.config;
    }
  },
  methods: {
    async otherLogin() {
      const url = location.protocol + "//" + location.host+'/h5';
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.mp_login.appId}&redirect_uri=${this.config.login_auth_url}/h5/login-middle?saas_redirect_url=${url}${this.$route.path}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    }
  },
  async created() {
    // 个别域名不展示微信登陆
    if(window.location.origin.indexOf('zhongshenedu')>-1){
      this.websiteUnUseWx = false
    }
    if (this.$pub.isWeiXin()) {
      if (this.$route.query.code) {
        this.$http
          .post(
            "/api/app/login",
            {
              code: this.$route.query.code,
              type: 10
            },
            "WXH5"
          )
          .then(res => {
            if (res.id) {
              this.$emit("successHandler", res);
            } else {
              this.$router.push({
                name: "BindMobile",
                query: {
                  openid: res.msg.split(",")[1],
                  unionid: res.msg.split(",")[0]
                }
              });
            }
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.otherLogin {
  width: 100%;
  margin-top: 100px;
  padding-bottom: 40px;
  text-align: center;
  p {
    position: relative;
    width: 145px;
    margin: 0 auto;
    font-size: 28px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #999;
    text-align: center;
    white-space: nowrap;
    &::before {
      position: absolute;
      top: 50%;
      left: -245px;
      width: 220px;
      height: 2px;
      background: linear-gradient(-90deg, #EDEDED, #FFFFFF);
      transform: translateY(-50%);
      content: ''
    }
    &::after {
      position: absolute;
      top: 50%;
      right: -245px;
      width: 220px;
      height: 2px;
      background: linear-gradient(-270deg, #EDEDED, #FFFFFF);
      transform: translateY(-50%);
      content: ''
    }
  }
  .txLogin {
    display: flex;
    margin-top: 36px;
    .wxLogin,
    .qqLogin {
      @extend %flex-center;
      flex: 1;
      span {
        font-size: 28px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(140, 140, 140, 1);
      }
    }
    .wxLogin {
      border-right: 1px solid #f1f1f1;
    }
    .wxLogin img {
      width: 70px;
      height: 70px;
    }
    .qqLogin img {
      width: 44px;
      height: 44px;
    }
  }
}
</style>
